// src/process-polyfill.js

if (typeof window !== 'undefined') {
    if (!window.process) {
        window.process = { env: {} };
    } else if (!window.process.env) {
        window.process.env = {};
    }
}
